import {createContext} from "react";

export const CancellationReasonContext = createContext({
    selectedReason: null,
    setReason: () => {},
    dayCount: 10,
    setDayCount: () => {}
})
